<template>
    <div class="terms-of-service">
        <div class="service-title ">
            <h3 class="cs-title-category"> {{ $t("term_of_service") }} </h3>
        </div>
        <div class="service-content">
            <div class="sr-icon">
                <img src="@/static/eMoneyLogo-tron_3.svg" width="60" height="60" alt="" class="cs-img-icon">
            </div>
            <h3 class="sr-title"> {{ $t("metfone_services") }}</h3>
            <p class="sr-subTitle"> {{ $t("term_sub_description") }} </p>
        </div>
        <div>
            <div class="">
                <p class="sr-description">{{ $t("by_using_the_metfone_service") }} <span class="aba-term-conditions">
                        {{ $t("aba_term_and_condition") }}</span> {{ $t("and_to_share_with_us") }}</p>
            </div>
            <div class="metfone-bottom-button">
                <van-button class="metfone-bottom-btn metfone-bottom-btn-yes" @click="handleAccept()">
                    {{ $t("term_accept") }} </van-button>
                <van-button class="metfone-bottom-btn metfone-bottom-btn-no" @click="handleCancel()">
                    {{ $t("term_cancel") }} </van-button>
            </div>
        </div>
    </div>
</template>

<script src="./index.js"></script>

<style src="./index.css" lang="css" scoped></style>
